import React from "react"
import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import Body from "../../components/Body/Body"
function HomePage(){

    return(
        <div className="home-page">
        <Header/>
        <Body/>
        <Footer/>
        </div>
    )
}

export default HomePage